import { Component, OnInit } from '@angular/core';
import { PlatformLocation } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-congratulation-sorry-page',
  templateUrl: './congratulation-sorry-page.component.html',
  styleUrls: ['./congratulation-sorry-page.component.scss']
})
export class CongratulationSorryPageComponent implements OnInit {

  constructor(location1: PlatformLocation, private router: Router) { 
    location1.onPopState(() => {
      // history.pushState( null, null,"");
      //  history.pushState(null, null,"/result");
      window.history.go(1);
      // this.backPressed = true;
      // console.log('pressed back! : ', this.backPressed);
      // this.getAllQuestions();
      return false;

    });
  }

  //testStatus: string = localStorage.getItem('testStatus');
 //testStatus = 'FAIL';
  testStatus = 'PASS';

  ngOnInit() {
    history.pushState(null, null, location.href);
    localStorage.clear();
    
  //const key=localStorage.getItem('userkey');
  //console.log(key);
  
  // if(key !== undefined)
  // {
   
  //    setTimeout(() => {
  //     window.location.href = 'https://economictimes.indiatimes.com/campusstar_v3_thankyou.cms?sid='+key
  //   }, 15000); 
  // }
    //localStorage.clear();
    // setTimeout(() => {
    //   window.location.href = 'https://economictimes.indiatimes.com/campusstar_v3_thankyou.cms?sid='
    // }, 15000); 
  }

  goToLink() {
    const link = 'https://economictimes.indiatimes.com/engage/campusstarcontact5.cms';
    window.open(link, '_blank');
  }

}
